var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 97,
    viewBox: "0 0 89 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3440_13808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 40.5C24.5 29.4543 33.4543 20.5 44.5 20.5C55.5457 20.5 64.5 29.4543 64.5 40.5C64.5 51.5457 55.5457 60.5 44.5 60.5C33.4543 60.5 24.5 51.5457 24.5 40.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.166 38.8997V35.8333C39.166 34.4188 39.7279 33.0623 40.7281 32.0621C41.7282 31.0619 43.0848 30.5 44.4993 30.5C45.9138 30.5 47.2703 31.0619 48.2705 32.0621C49.2707 33.0623 49.8326 34.4188 49.8326 35.8333V38.8997H51.0326C52.4317 38.8997 53.566 40.034 53.566 41.4331V47.9664C53.566 49.3655 52.4317 50.4997 51.0326 50.4997H37.966C36.5668 50.4997 35.4326 49.3655 35.4326 47.9664V41.4331C35.4326 40.034 36.5668 38.8997 37.966 38.8997H39.166ZM41.6709 33.0049C42.421 32.2548 43.4384 31.8333 44.4993 31.8333C45.5602 31.8333 46.5776 32.2548 47.3277 33.0049C48.0779 33.7551 48.4993 34.7725 48.4993 35.8333V38.8997H40.4993V35.8333C40.4993 34.7725 40.9207 33.7551 41.6709 33.0049ZM39.8138 40.2331C39.82 40.2332 39.8263 40.2333 39.8326 40.2333C39.8389 40.2333 39.8452 40.2332 39.8514 40.2331H49.1471C49.1534 40.2332 49.1597 40.2333 49.166 40.2333C49.1722 40.2333 49.1785 40.2332 49.1848 40.2331H51.0326C51.6954 40.2331 52.2326 40.7703 52.2326 41.4331V47.9664C52.2326 48.6291 51.6954 49.1664 51.0326 49.1664H37.966C37.3032 49.1664 36.766 48.6291 36.766 47.9664V41.4331C36.766 40.7703 37.3032 40.2331 37.966 40.2331H39.8138Z",
    fill: "#6429CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3440_13808",
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3440_13808"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3440_13808",
    result: "effect2_dropShadow_3440_13808"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3440_13808",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlock);
export default __webpack_public_path__ + "static/media/lockBlock.d7be4d1b0c08c7d0dde66fb928b28017.svg";
export { ForwardRef as ReactComponent };